import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ConsumptionSourceForm from '../Forms/ConsumptionSourceForm';

const AddEditConsumptionSourceModal = ({
	dataConsumptionSource,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	edit_environment
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Fuente de Consumo
			</ModalHeader>

			<ConsumptionSourceForm
				dataConsumptionSource={dataConsumptionSource}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				edit_environment={edit_environment}
			/>
		</Modal>
	);
};

export default AddEditConsumptionSourceModal;
